import type { Ceviri } from "../tip";
import type { kabuk as tr } from "../tr/kabuk";

/** English dictionary · kabuk. */
export const kabuk: Ceviri<typeof tr> = {
  sayfa: {
    "ana-sayfa": "Home",
    hesaplar: "Accounts",
    hareketler: "Transactions",
    "ice-aktar": "Import",
    pozisyonlar: "Positions",
    rapor: "Holdings",
    grafik: "Daily Analysis",
    "donemsel-analiz": "Period Returns",
    "sanal-hesaplar": "Virtual Accounts",
    izleme: "Tracking",
    fiyatlar: "Manual price",
    degerleme: "Manual valuation",
    ayarlar: "Settings",
  },

  menu: {
    anaSayfa: "Home",
    raporlar: "Reports",
    hesapIslemleri: "Account actions",
    ayarlar: "Settings",
    kisaAnaSayfa: "Home",
    icerigeGec: "Skip to content",
    anaGezinti: "Main navigation",
    tutarlariGizle: "Hide amounts",
    hizliGezinti: "Quick navigation",
    asama: "Stage 1 · local records",
    sema: (v: number) => `schema v${v}`,
    kaliciDegil: "storage not persistent",
    kapat: "Close",
    menu: "Menu",
    sahteDepo: "Development mode: data is held in a FAKE in-memory store. It is erased when you reload the page.",
  },

  acilis: {
    vtAciliyor: "Opening local database…",
    kasaAciliyor: "Opening vault…",
    tanitimaDon: "← Back to introduction",
    baslatilamadi: "Parafon could not start",
    vtAcilamadi: "Local database could not be opened",
    dokunulmadi:
      "Your data was not touched. If the problem persists, remember that you cannot take a backup before clearing the browser's site data — support is needed in that case.",
    sayfayiYenile: "Reload page",
  },

  merkez: {
    kosumdaYok: "The central server is not connected in this run — search and tracking status are off.",
    kosumdaOnbellekYok: "The device price cache is not connected in this run.",
    ekrandaYok: "The central server is not connected to this screen — search and tracking status cannot be read.",
    ekrandaOnbellekYok: "The device price cache is not connected to this screen.",
    kapatildi: "The central server is turned off for this session (?merkez=kapali). Search and sync are off.",
  },

  esitleme: {
    sebep: {
      acilis: "on opening",
      "one-gelme": "when the tab came to front",
      elle: "manual",
    },
    fiyat: (m: string) => `price: ${m}`,
    onbellek: (m: string) => `cache: ${m}`,
    kur: (m: string) => `exchange rate: ${m}`,
    kasa: (m: string) => `vault: ${m}`,
  },

  hataSinir: {
    baslik: "The interface hit an unexpected error",
    dokunulmadi: "Your data was not touched — this error happened only in the layer that draws the screen.",
    teknikAyrinti: "Technical details",
    yenidenCiz: "Redraw screen",
    sayfayiYenile: "Reload page",
  },

  sunucuYok: {
    dosyalar: "Parafon's app files could not be fetched from the server, so the local database was not opened.",
    yerinde:
      "Your data is on this device, where it was; none of it was touched. Press the button below once the server is reachable again.",
    yenidenDene: "Try again",
    temizlemeyinBaslik: "Do not clear the browser's site data",
    temizlemeyin:
      "The vault is kept in this device's browser storage. \"Clear site data\" erases it from this device; it comes back from your cloud backup if you have one. That does not fix this, because the problem is on the server.",
    teknikAyrinti: "Technical details",
  },

  baskaSekme: {
    baslik: "Parafon is open in another tab.",
    tekSekme:
      "The local database can be open in only one tab at a time. Another tab (or window) is holding the database right now, so this tab cannot reach the data.",
    guvende:
      "Your data is safe and intact. What to do: close the other tab where Parafon is open, then press the button below.",
    deneniyor: "Trying…",
    yenidenDene: "Try again",
    sekmeyiKapat: "Close this tab",
    nedenBaslik: "Why is this?",
    neden:
      "The database runs with a file lock in the browser's OPFS storage. The lock stops two tabs from writing the same file at once and corrupting the data. Failing with a clear error instead of silently running corrupted is a deliberate choice.",
  },

  hata: {
    LOCKED_BY_OTHER_TAB: "Parafon is open in another tab.",
    OPFS_UNAVAILABLE: "This browser does not support local database storage (OPFS).",
    MIGRATION_FAILED: "The database schema update failed. Your data was not touched.",
    NOT_FOUND: "Record not found. It may have been deleted elsewhere.",
    VALIDATION: "The values entered were not accepted.",
    TIMEOUT: "The request timed out.",
    SERVER_UNAVAILABLE: "Cannot reach the server.",
    KILITLI: "The vault is locked.",
    KURULUM_GEREKLI: "No vault has been set up on this device yet.",
    DEFTER_KAYIP: "The encrypted vault was not found on this device.",
    BASKA_DEFTER: "This backup belongs to another vault; it is not merged with the vault on this device.",
    UNKNOWN: "An unexpected error occurred.",
  },

  depo: {
    modulYuklenemedi: "device database module could not be loaded",
    donemselYok: "Period Returns is not in this build.",
    sepetYok: "Basket breakdown is not in this build.",
    getiriOzetiYok: "Return summary is not in this build.",
    yedektenKurYok: "Restoring from the cloud is not in this build; reload the page.",
    parolaDogrulaYok: "Password check is not in this build; reload the page.",
  },
};
